import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanText } from "@lib/titan2/dist/game/control/TitanText";
import { EventHandler } from "@lib/titan2/dist/util/event/EventHandler";
import { Timer } from "@lib/titan2/dist/util/time/Timer";
import { gsap } from "gsap";
/**
 * GameSummaryCell.ts
 */
export class GameSummaryCell extends AbstractGameView {
    create() {
        super.create();
        this.createBackground();
        this.createNameField();
        this.createAmountField();
        this.createMessageTimer();
    }
    createBackground() {
        this.background = this.assetManager.getSprite(this.uiProperties.backgroundProperties);
        this.addChild(this.background);
    }
    createIcon() {
        this.icon = this.assetManager.getSprite(this.uiProperties.iconProperties);
        this.addChild(this.icon);
    }
    createNameField() {
        this.nameField = TitanText.createField(this, this.uiProperties.nameFieldProperties);
        this.addChild(this.nameField);
        this.nameField.clear();
    }
    createAmountField() {
        this.amountField = TitanText.createField(this, this.uiProperties.amountFieldProperties);
        this.addChild(this.amountField);
        this.amountField.clear();
    }
    createMessageTimer() {
        this.messageTimer = new Timer(50);
        this.messageTimer.onUpdate(this.handleMessageTimerUpdate, this);
    }
    reset() {
        this.background.alpha = 0;
        this.amountField.clear();
        this.nameField.clear();
    }
    play() {
        this.backgroundTween = gsap.to(this.background, { alpha: 1, duration: 1 });
        this.callAfter(0.5, this.handleIconTweenComplete);
    }
    update(amount, label) {
        this.reset();
        this.updateMessages(amount, label);
    }
    updateMessages(amount, label) {
        this.updateNameMessage(label ? label : this.langManager.getLang(this.uiProperties.nameLangKey));
        this.updateAmountMessage(amount);
    }
    updateNameMessage(nameString) {
        this.nameMessage = nameString.split("");
        this.nameField.setText(nameString, true);
        this.nameField.clear();
    }
    updateAmountMessage(amount) {
        let amountMessage = this.uiProperties.currency ? this.formatCurrency(amount) : amount.toString();
        this.amountMessage = amountMessage.split("");
        this.amountField.setText(amountMessage, true);
        this.amountField.clear();
    }
    handleIconTweenComplete() {
        this.updateMessage();
        this.messageTimer.start();
    }
    handleMessageTimerUpdate() {
        this.updateMessage();
    }
    updateMessage() {
        if (this.nameMessage.length > 0) {
            this.nameField.setText(this.nameField.getText() + this.nameMessage.shift(), true);
        }
        else if (this.amountMessage.length > 0) {
            this.amountField.setText(this.amountField.getText() + this.amountMessage.shift(), true);
        }
        else {
            this.messageTimer.stop();
            this.handleComplete();
        }
    }
    handleComplete() {
        this.callHandler(this.completeHandler);
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    getHeight() {
        return this.uiProperties.size?.y || this.height;
    }
    getWidth() {
        return this.uiProperties.size?.x || this.width;
    }
}
//# sourceMappingURL=GameSummaryCell.js.map